import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { DATE_SHORTCUTS } from '@utils/constants';
import { calcShortcutInterval } from '@utils';
import DatePicker from '@src/components/common/DatePicker';

const isDateDisabled = (currentDate) => {
  if (!currentDate) return true;
  return (
    currentDate.isAfter(moment(), 'day') ||
    currentDate.isBefore(moment().subtract(90, 'days'), 'day')
  );
};

const buildShortcuts = () => [
  [DATE_SHORTCUTS.sevenDays, calcShortcutInterval(DATE_SHORTCUTS.sevenDays)],
  [DATE_SHORTCUTS.past30Days, calcShortcutInterval(DATE_SHORTCUTS.past30Days)],
  [DATE_SHORTCUTS.past90Days, calcShortcutInterval(DATE_SHORTCUTS.past90Days)],
];

export const DatePickerModifier = (props) => {
  const pickerRef = useRef();

  useEffect(() => {
    const picker = pickerRef.current;
    if (picker && !picker.isModelOpen()) {
      picker.reset();
    }
  }, [props.interval]);

  return (
    <DatePicker
      disabledDate={isDateDisabled}
      shortcuts={buildShortcuts()}
      ref={pickerRef}
      defaultValue={props.interval}
      {...props}
    />
  );
};
